import { ViewableBreadcrumbService } from "process/breadcrumb.service";
import { BreadcrumbItem } from "common/breadcrumb/breadcrumb-item";

type ViewableProcess = stages.process.ViewableProcess;
type ProcessTreeItem = stages.process.ProcessTreeItem;

export class ProcessBreadcrumbService extends ViewableBreadcrumbService {
	override getRootElement(process: ViewableProcess, isEditing: boolean): BreadcrumbItem {
		return this.getBreadcrumbElement(process, isEditing);
	}

	override getBreadcrumbElement(element: ProcessTreeItem, isEditing: boolean): BreadcrumbItem {
		const breadcrumbElement = new BreadcrumbItem();
		breadcrumbElement.label = element.label;
		breadcrumbElement.route = isEditing
			? ["../../../..", "process", element.type.ident, element.identity]
			: ["../../..", "process", element.type.ident, element.identity];

		if (element.tailored) {
			breadcrumbElement.listItemClass = "tailored";
		}

		return breadcrumbElement;
	}
}
